module.exports = __webpack_public_path__ + "img/azhrwm.95998d42.png";